import { render } from "./AddMeldingDoelgroepView.vue?vue&type=template&id=724c7b68&scoped=true"
import script from "./AddMeldingDoelgroepView.vue?vue&type=script&lang=js"
export * from "./AddMeldingDoelgroepView.vue?vue&type=script&lang=js"

import "./AddMeldingDoelgroepView.vue?vue&type=style&index=0&id=724c7b68&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724c7b68"]])

export default __exports__